module.exports = "<section class=\"container-fluid with-maxwidth chapter\">\r\n    <my-estadoResultados-consultar></my-estadoResultados-consultar>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Contabilidad/estadoResultados/estadoResultados.component.html
// module id = ./src/app/Contabilidad/estadoResultados/estadoResultados.component.html
// module chunks = main